import * as React from "react";

import { AnalyticsProvider } from "./analytics";
import { AuthProvider } from "./auth";
import { DomainServicesProvider } from "./DomainServices";
import { FileTransferProvider } from "./FileTransfer";
import { HttpClientProvider } from "./HttpClient";
import { Localization } from "./LocalizationProvider";
import { NavigationProvider } from "./navigation";
import { QueryProvider } from "./QueryClient";
import { MUIThemeProvider } from "./theme/MUIThemeProvider";

const Providers = ({ children }: React.PropsWithChildren) => {
  return (
    <HttpClientProvider>
      <MUIThemeProvider>
        <QueryProvider>
          <Localization>
            <AuthProvider>
              <DomainServicesProvider>
                <FileTransferProvider>
                  <NavigationProvider>
                    <AnalyticsProvider>{children}</AnalyticsProvider>
                  </NavigationProvider>
                </FileTransferProvider>
              </DomainServicesProvider>
            </AuthProvider>
          </Localization>
        </QueryProvider>
      </MUIThemeProvider>
    </HttpClientProvider>
  );
};

export default Providers;
